// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YFJlHIgwTqiGu8 {
  max-width: calc(280px * 2 + 12px);
  margin: var(--ds-space-0, 0) auto;
  text-align: center;
}
.aZEJ0SuFeWJE4p {
  display: flex;
  gap: var(--ds-space-150, 10px);
  align-items: center;
  justify-content: center;
}
.sJWpGUnUCyCFB6 {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 12px;
}
.sJWpGUnUCyCFB6 > * {
  flex: 0 1 280px;
}
@media (max-width: 750px) {
  .sJWpGUnUCyCFB6 {
    flex-direction: column-reverse;
    align-items: center;
    margin-top: var(--ds-space-300, 24px);
  }
  .sJWpGUnUCyCFB6 > * {
    width: 100%;
    max-width: 280px;
  }
}
.sCsQ4e8SYjjUGY {
  margin: var(--ds-space-0, 0) auto;
  margin-top: var(--ds-space-200, 16px);
  text-align: center;
}
.kO6fKfEsdfmvdJ {
  width: 80%;
  margin: var(--ds-space-0, 0) auto;
  text-align: center;
}
.LSxOqWSwuU2w4D {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.bSHvVgbCCrM4Na {
  margin-right: var(--ds-space-050, 3px);
  color: var(--ds-text, #091e42);
  font-size: 29px;
  font-weight: var(--ds-font-weight-semibold, 600);
  line-height: 30px;
}
.uMtX1kzwWrzwsf {
  color: token('color.text.subtle', '#44546F');
  font-size: 12px;
  font-style: normal;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}
.EBqkA7Mdon9TsI {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding-bottom: 1px;
  border-bottom: 1px dashed var(--ds-background-accent-gray-subtle, #8590a2);
  cursor: pointer;
}
.jHswUjLtEYZWJw {
  font-size: 12px;
  font-weight: var(--ds-font-weight-bold, bold);
}
.uryRwK0IXsv8JL {
  margin-left: var(--ds-space-100, 8px);
}
.G7NyiCURD6m9MW {
  border: 3px solid var(--ds-border-discovery, #8270db);
  border-radius: var(--ds-border-radius-200, 8px);
  background: var(--ds-background-discovery, #f3f0ff);
}
.G7NyiCURD6m9MW legend {
  margin: auto;
  /* to center */
  padding: var(--ds-space-100, 8px) var(--ds-space-200, 15px);
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  font-style: normal;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 16px;
}
.YxQR7quJfppF23 {
  margin-top: var(--ds-space-150, 12px);
  border: 3px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-200, 8px);
}
.dXWkZoo6VResXy {
  flex: 1;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: var(--ds-space-0, 0) 36px var(--ds-space-200, 14px);
}
.dXWkZoo6VResXy li {
  margin-top: var(--ds-space-150, 12px);
  font-size: 14px;
}
.VEh6XdDFwtu3io {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  margin-bottom: var(--ds-space-200, 15px);
  padding: var(--ds-space-0, 0);
  border: 0;
}
.UZUZPQatDP4ovK {
  max-width: calc(280px * 2 + 12px);
  margin: var(--ds-space-0, 0) auto;
}
`, ""]);
// Exports
export var modalHeader = `YFJlHIgwTqiGu8`;
export var featureSelectionContainer = `aZEJ0SuFeWJE4p`;
export var plansContainer = `sJWpGUnUCyCFB6`;
export var stadardHeader = `sCsQ4e8SYjjUGY`;
export var premiumHeader = `kO6fKfEsdfmvdJ`;
export var pricingSection = `LSxOqWSwuU2w4D`;
export var pricingLable = `bSHvVgbCCrM4Na`;
export var billingPeriodLable = `uMtX1kzwWrzwsf`;
export var tooltipTarget = `EBqkA7Mdon9TsI`;
export var featureListTitle = `jHswUjLtEYZWJw`;
export var featureSpan = `uryRwK0IXsv8JL`;
export var premiumPlanFieldSet = `G7NyiCURD6m9MW`;
export var standardPlanFieldSet = `YxQR7quJfppF23`;
export var featureList = `dXWkZoo6VResXy`;
export var fieldSet = `VEh6XdDFwtu3io`;
export var warning = `UZUZPQatDP4ovK`;
export default ___CSS_LOADER_EXPORT___;
